import moment from 'moment'
import { Certificate } from '../../models/ResponseModel'
export type SmartCard = {
  terminalList: string[]
  osName?: string
  osArch?: string
  osVersion?: string
  selectedTerminal?: string
  certificateList: Certificate[]
  selectedCertificate?: Certificate
  pin: string
  errorDescription?: string
  wrapperFile?: string
  useWrapper?: boolean
  useApdu: boolean
}

export const initialSmartCardState: SmartCard = {
  terminalList: ['ACS ACR38U-CCID'],
  certificateList: [
    {
      subject: 'ERDEM BAŞ',
      serialNumber: '41351160494',
      validStartDate: moment('2019-06-15T00:53:00'),
      validEndDate: moment('2020-06-14T15:07:00'),
      isQualified: true,
      id: '32B6CA9232DD2AF888121B459967BEA6',
      status: {
        description: 'Sertifika Geçerli.',
        isValid: true,
      },
    },
  ],
  pin: '1453',
  selectedTerminal: 'ACS ACR38U-CCID',
  selectedCertificate: {
    subject: 'ERDEM BAŞ',
    serialNumber: '41351160494',
    validStartDate: moment('2019-06-15T00:53:00'),
    validEndDate: moment('2020-06-14T15:07:00'),
    isQualified: true,
    id: '32B6CA9232DD2AF888121B459967BEA6',
    status: {
      description: 'Sertifika Geçerli.',
      isValid: true,
    },
  },
  useApdu: false,
}
//MYTODO

export const initialState: SmartCard = {
  terminalList: [],
  certificateList: [],
  pin: '',
  useApdu: false,
}

export enum ActionTypes {
  CERTIFICATE_LIST_REQUEST = '@@main/LIST_CERTIFICATE_REQUEST',
  CERTIFICATE_LIST_FULFILLED = '@@main/LIST_CERTIFICATE_FULFILLED',
  CERTIFICATE_LIST_REJECTED = '@@main/LIST_CERTIFICATE_REJECTED',
  SET_STATE = '@@main/SET_STATE',
  TERMINAL_LIST_REQUEST = '@@main/LIST_TERMINAL_REQUEST',
  TERMINAL_LIST_FULFILLED = '@@main/LIST_TERMINAL_FULFILLED',
  SET_SMART_CARD = '@@main/SET_SMART_CARD',
}
